import { jsx as o } from "react/jsx-runtime";
import { useMultiStyleConfig as s } from "@chakra-ui/react";
import "../../forms/Button/Button.mjs";
import { IconButton as n } from "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
import { XmarkIcon as m } from "../../icons/componentIcons.mjs";
const i = (t) => {
  switch (t) {
    case "lg":
      return "md";
    case "sm":
      return "xs";
    default:
      return "sm";
  }
}, u = (t) => {
  switch (t) {
    case "lg":
      return "xl";
    case "sm":
      return "xs";
    default:
      return "md";
  }
}, g = ({ size: t = "md", ...r }) => {
  const e = s("CloseButtonCustom");
  return /* @__PURE__ */ o(
    n,
    {
      sx: e,
      icon: /* @__PURE__ */ o(m, { variant: "light", size: u(t), viewBox: "30 100 320 320" }),
      size: i(t),
      ...r
    }
  );
};
export {
  g as CloseButton
};
